
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {}
})
export default class TramiteCardComponent extends Vue {
  @Prop({ type: Object, required: true }) tramite!: Record<string, any>;
  @Prop({ type: Boolean, default: false }) scrollToTitle!: boolean;

  get visibleTags() {
    return (this.tramite.tags || []).slice(0, 3);
  }

  get remainingTags() {
    return Math.max(
      (this.tramite.tags || []).length - this.visibleTags.length,
      0
    );
  }

  private goToTramite(tramite: any) {
    this.$router.push({
      path: `/portal-servicios/${tramite.slug}`,
      query: this.scrollToTitle ? { scrollTo: "title" } : {}
    });
  }
}
